import Immutable from 'seamless-immutable';
// ---- external imports ----

import * as types from './actionTypes';
// ---- local imports ----

const initialState = Immutable({
	id: 0,
	slug: null,
	power: {
		msg: null,
		info: null
	},
	completionMsg: null,
	lastUpdate: Date.now()
});

export default function reduce(state = initialState, action = {}) {
	switch (action.type) {
	case types.CHARACTER_LOADED:
	case types.CHARACTER_SELECTED:
		return state.merge({
			...action.character,
			lastUpdate: Date.now()
		});
	default:
		return state;
	}
}
